$('document').ready(function () {

	// Page Loader
	$('.page-loader').fadeOut();

	$(".mobile-menu-button").click(function () {
		$(".mobile-menu").slideToggle();
		$(this).toggleClass("active");
		$('body').toggleClass("mobile-menu-active");
	});

	$('.search-container').click(function (event) {
		event.preventDefault();
		if ($('.search-container').hasClass('active')) {
			//$('.search-container').removeClass('active');
		} else {
			$('.search-container').addClass('active');
			$('.search-container #search').val('');
			setTimeout(function () {
				$('.search-container #search').focus();
			}, 400);

		}
	});

	$('.mobile-menu ul li.menu-item-has-children > a').click(function (event) {
		if ($(this).parent().hasClass('active')) {
			$(this).parent().removeClass('active');
		} else {
			$(this).parent().addClass('active');
			event.preventDefault();
		}
	});

	$(document).mouseup(function (e) {
		var container = $(".search-container");

		// if the target of the click isn't the container nor a descendant of the container
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			container.removeClass('active');
		}
	});

	function initializeAccordion($scope) {
		// If $scope is not defined, default to the entire document
		$scope = $scope || $(document);

		// Initialize accordion within the scope
		$scope.find(".accordion__title").off("click").on("click", function (e) {
			e.preventDefault();
			var $this = $(this);

			if (!$this.hasClass("accordion-active")) {
				$scope.find(".accordion__content").slideUp(400);
				$scope.find(".accordion__title").removeClass("accordion-active");
			}

			$this.toggleClass("accordion-active");
			$this.next().slideToggle();
		});
	}

	// Initialize accordion globally on page load
	$(document).ready(function () {
		initializeAccordion(); // Affects all accordions
	});

	// Reinitialize accordion specifically in the FacetWP template after AJAX load
	$(document).on('facetwp-loaded', function () {
		initializeAccordion($('.facetwp-template')); // Scoped to FacetWP pagination area
	});



	$(".flex-panel").each(function () {
		if ($(this).find('.list-wrap').length !== 0) {
			$(this).find('.row > div').removeClass('justify-content-center');
			$(this).find('.row > div').addClass('justify-content-start');
		}
	});


	$('.pop-up-link').click(function (event) {
		event.preventDefault();

		/*
		var name = $(this).data('name');
		var position = $(this).data('position');
		var bio = $(this).data('bio');
		$('.black_overlay').fadeIn();
		$('.white_content').fadeIn();
		$('.white_content').find('.member-name').html(name);
		$('.white_content').find('.member-position').html(position);
		$('.white_content').find('.member-bio').html(bio);
		*/
	});
	$('.close-popup').click(function (event) {
		event.preventDefault();
		$('.black_overlay').fadeOut();
		$('.white_content').fadeOut();
	});

	if ($(window).scrollTop() > 20) {
		$('.header').addClass('sticky');
	}

	// Take Home Calculator
	if ($("#thpform")[0]) {

		$("#thp_rate").slider({
			min: 15,
			max: 100,
			values: [20],
			slide: function (event, ui) {
				$("#thp_rate span").text("£" + ui.values[0]);
				calculateTool();
			}
		});
		$("#thp_rate span").text("£" + $("#thp_rate").slider("values", 0));

		$("#thp_hours").slider({
			min: 15,
			max: 80,
			values: [40],
			slide: function (event, ui) {
				$("#thp_hours span").text(ui.values[0]);
				calculateTool();
			}
		});
		$("#thp_hours span").text($("#thp_hours").slider("values", 0));

		function calculateTool() {
			// Make calculation 
			var thp_rate = $('#thp_rate span').text().replace('£', '');
			var thp_hours = $('#thp_hours span').text();
			var payment_cycle = $('input[name="payment_cycle"]:checked').attr('ID');

			var assignment_income = thp_rate * thp_hours;

			// Margin 
			var margin = assignment_income - 20;

			// Employer's National Insurance @ 13.8%
			if (margin > 175) {
				margin_ni1 = margin - 175;
				var employers_national_insurance = margin_ni1 * -0.1213;
			}

			// Apprenticeships levy
			var apprenticeships_levy = margin + employers_national_insurance;
			var apprenticeships_levy = apprenticeships_levy * -0.005;

			// Gross Pay (inc. Holiday Pay)
			var gross_pay = margin + employers_national_insurance + apprenticeships_levy;

			var personal_allowance = -242;

			// Taxable Pay
			var taxable_pay = gross_pay + personal_allowance;

			// PAYE @20%
			var paye20 = 0;
			if (taxable_pay > 0) {
				if (taxable_pay > 725) {
					var paye20 = -725 * 0.2;
				} else {
					var paye20 = taxable_pay * -0.2;
				}
			}

			// PAYE @40%
			var paye40 = 0;
			if (paye20 <= -145) {
				if (2406 >= taxable_pay) {
					var paye40 = (Math.floor(taxable_pay) - 725) * -0.4;
				} else {
					var paye40 = 1681 * -0.4;
				}
			}

			// PAYE @45%
			var paye45 = 0;
			if (-paye40 < (1681 * 0.4)) {
				var paye45 = 0;
			} else {
				var paye45 = (taxable_pay - 2406) * -0.45;
			}

			// EEs National Insurance @ 8%
			var ee_national_insurance_8 = 0;
			if (gross_pay - 967 < 0) {
				if (gross_pay - 242 < 0) {
					var ee_national_insurance_8 = 0;
				} else {
					var ee_national_insurance_8 = (gross_pay - 242) * -0.08;
				}
			} else {
				var ee_national_insurance_8 = 725 * -0.08;
			}

			// EEs National Insurance @ 2%
			var ee_national_insurance_2 = 0;
			if (gross_pay > 967) {
				var ee_national_insurance_2 = (gross_pay - 967) * -0.02;
			}

			var net_pay = paye20 + paye40 + paye45 + ee_national_insurance_8 + ee_national_insurance_2 + gross_pay;

			if (payment_cycle == 'payment_cycle_monthly') {
				var net_pay = net_pay * 52;
				var net_pay = net_pay / 12;
			}

			var earning1 = net_pay;
			//var earning3 = net_pay;
			//var earning1 = earning1.toFixed(2);

			/*
			console.log("Umbrella: assignment_income:", assignment_income);
			console.log("Umbrella: margin:", margin);
			console.log("Umbrella: employers_national_insurance:", employers_national_insurance);
			console.log("Umbrella: apprenticeships_levy:", apprenticeships_levy);
			console.log("Umbrella: gross_pay:", gross_pay);
			console.log("Umbrella: personal_allowance:", personal_allowance);
			console.log("Umbrella: taxable_pay:", taxable_pay);
			console.log("Umbrella: paye20:", paye20);
			console.log("Umbrella: paye40:", paye40);
			console.log("Umbrella: paye45:", paye45);
			console.log("Umbrella: ee_national_insurance_8:", ee_national_insurance_8);
			console.log("Umbrella: ee_national_insurance_2:", ee_national_insurance_2);
			console.log("Umbrella: net_pay:", net_pay);
			console.log("Umbrella: result:", earning1);
			*/

			// CIS
			var earning2 = (assignment_income - 20) * 0.8;

			if (payment_cycle == 'payment_cycle_monthly') {
				var earning2 = earning2 * 52;
				var earning2 = earning2 / 12;
			}

			//console.log("CIS: = (gross_pay - 20) * 0.8 =", earning2);

			// Limited Company
			var Salaries = -242;
			var Expenses = -150;
			var fee = -39;
			//var fee = 0;
			var Net_Profit = assignment_income + Salaries + Expenses + fee;
			var Corporation_Tax = 0;

			if (Net_Profit * 52 > 250000) {
				Corporation_Tax = -(Net_Profit) * 0.25;
			} else if (Net_Profit * 52 > 50000) {
				Corporation_Tax = -((((Net_Profit * 52) - 50000) / 52) * 0.265) - (50000 / 52) * 0.19;
			} else if (Net_Profit * 52 <= 50000) {
				Corporation_Tax = -(Net_Profit) * 0.19;
			}

			var Net_Profit_After_Tax = Net_Profit + Corporation_Tax;

			var Expenses_Received_Gross = 150;
			var Net_Salary = 242;
			var Dividend = (Net_Profit_After_Tax > 0) ? Net_Profit_After_Tax : 0;

			var Total_Aggregate_Weekly_Pay_Received = Net_Salary + Expenses_Received_Gross + Dividend;

			var Annual_Dividend_Earnings = Dividend * 52;

			var Additional_Personal_Tax_on_dividends = 0;
			if (Annual_Dividend_Earnings > 0) {
				if (Annual_Dividend_Earnings <= 500) {
					Additional_Personal_Tax_on_dividends = 0;
				} else if (Annual_Dividend_Earnings <= 37700) {
					Additional_Personal_Tax_on_dividends = (Annual_Dividend_Earnings - 500) * 0.0875;
				} else if (Annual_Dividend_Earnings <= 112570) {
					Additional_Personal_Tax_on_dividends = (37700 - 500) * 0.0875 + (Annual_Dividend_Earnings - 37700) * 0.3375;
				} else {
					Additional_Personal_Tax_on_dividends = (37700 - 500) * 0.0875 + (112570 - 37700) * 0.3375 + (Annual_Dividend_Earnings - 112570) * 0.3935;
				}
			}

			var Annual_Salary = Net_Salary * 52;
			var Annual_Expenses = Expenses_Received_Gross * 52;
			var Net_Weekly_Projected_Income = (Annual_Dividend_Earnings + Annual_Salary + Annual_Expenses - Additional_Personal_Tax_on_dividends) / 52;

			var earning3 = Net_Weekly_Projected_Income;

			if (payment_cycle == 'payment_cycle_monthly') {
				var earning3 = earning3 * 52;
				var earning3 = earning3 / 12;
			}

			/*console.log("Limited Company: Assignment Income: ", assignment_income);
			console.log("Limited Company: Net Profit: ", Net_Profit);
			console.log("Limited Company: Corporation Tax: ", Corporation_Tax);
			console.log("Limited Company: Net Profit After Tax: ", Net_Profit_After_Tax);
			console.log("Limited Company: Total Aggregate Weekly Pay Received: ", Total_Aggregate_Weekly_Pay_Received);
			console.log("Limited Company: Annual Dividend Earnings: ", Annual_Dividend_Earnings);
			console.log("Limited Company: Additional Personal Tax on dividends: ", Additional_Personal_Tax_on_dividends);
			console.log("Limited Company: Annual Salary: ", Annual_Salary);
			console.log("Limited Company: Annual Expenses: ", Annual_Expenses);
			console.log("Limited Company: Net Weekly Projected Income: ", Net_Weekly_Projected_Income);
			*/

			var formattedEarning1 = earning1.toFixed(2);
			var formattedCurrency1 = '£' + parseFloat(formattedEarning1).toLocaleString('en', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
			$('.calculator-tool-results .earning-1').text(formattedCurrency1);

			var formattedEarning2 = earning2.toFixed(2);
			var formattedCurrency2 = '£' + parseFloat(formattedEarning2).toLocaleString('en', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
			$('.calculator-tool-results .earning-2').text(formattedCurrency2);

			/*
			var formattedEarning3 = earning3.toFixed(2);
			var formattedCurrency3 = '£' + parseFloat(formattedEarning3).toLocaleString('en', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
			$('.calculator-tool-results .earning-3').text(formattedCurrency3);
			*/

			/*
			$('html, body').animate({
				scrollTop: $('.calculator-tool-results').offset().top - 100,
			}, 1000);
			*/
		}

		/*
		$('.thp-calculate').click(function (event) {
			event.preventDefault();
			calculateTool();
		});
		$('.calc-slider').slider().bind('slidechange', function (event, ui) {
			calculateTool();
		});
		*/

		calculateTool();

		$('input[name="payment_cycle"]').on('click change', function (e) {
			calculateTool();
		});

	}

	// If vacancies
	if ($('body').hasClass('page-vacancies')) {

		if ($('#panel-1').length != 0) {
			if ($("p:contains('Vacancies')")) {
				$('.count-box').parent().addClass('hide');
				$('.count-box').appendTo($("p:contains('Vacancies')"));
			}
		}

	}

	// Initial check on page load
	loadTrustpilotWidget();

	// Any anchor
	$('a[href^="#"]').on('click', function (e) {
		e.preventDefault();

		// Get the href attribute value
		var href = $(this).attr('href');

		// Check if href starts with '#'
		if (href.startsWith('#')) {
			// Extract the class name from href (remove the leading '#')
			var className = href.slice(1);

			// Get the target element by class name
			var targetElement = $(href);

			// If target element found, animate scroll
			if (targetElement.length > 0) {
				var headerHeight = $('.header').outerHeight();

				$('html, body').animate({
					scrollTop: targetElement.offset().top - headerHeight
				}, 1600); // Duration in milliseconds (1000 ms = 1 second)
			}
		}
	});

});

$(window).scroll(function () {
	let scroll = $(window).scrollTop();
	if (scroll > 20) {
		$('.header').addClass('sticky');
	} else {
		$('.header').removeClass('sticky');
	}
});

// Function to check if the screen size is at least 768px
function loadTrustpilotWidget() {
	//if (window.matchMedia("(min-width: 768px)").matches) {
	var script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
	script.async = true;
	document.head.appendChild(script);
	//}
}

// Listen for window resize events to handle dynamic changes
window.addEventListener('resize', function () {
	// Remove any existing Trustpilot widget script if the screen size becomes less than 768px
	if (!window.matchMedia("(min-width: 768px)").matches) {
		var existingScript = document.querySelector('script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]');
		if (existingScript) {
			existingScript.parentNode.removeChild(existingScript);
		}
	} else {
		// Ensure the script is loaded if the screen size becomes at least 768px
		if (!document.querySelector('script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]')) {
			loadTrustpilotWidget();
		}
	}
});

// Census download
document.addEventListener('wpcf7mailsent', function (event) {

	if (event.detail.contactFormId === 1573 || event.detail.contactFormId === 1567) {

		// Static URL of the PDF file to download
		var pdfUrl = 'https://wearesapphire.co.uk/contracting/wp-content/uploads/sites/3/2024/09/Sapphire-Contracting-Census-2024.pdf';

		// Create a temporary link element
		var link = document.createElement('a');
		link.href = pdfUrl;
		link.download = ''; // Empty string triggers download
		link.target = '_blank'; // Open in a new tab

		// Append the link to the body
		document.body.appendChild(link);

		// Programmatically click the link to trigger the download
		link.click();

		// Remove the link from the document
		document.body.removeChild(link);
	}
}, false);